export const CRM_STAGE_OPTIONS = [
  { value: "novo", label: "Novo" },
  { value: "qualificado", label: "Qualificado" },
  { value: "visita", label: "Visita" },
  { value: "proposta", label: "Proposta" },
  { value: "ganho", label: "Ganho" },
  { value: "perdido", label: "Perdido" },
];

export const DEFAULT_CRM_CATEGORY_ID = "geral";

export const CRM_ACTIVITY_TYPE_LABELS = {
  note: "Nota",
  message: "Mensagem",
  stage: "Estágio",
  visit: "Visita",
  proposal: "Proposta",
  calculation: "Cálculo",
  reminder: "Lembrete",
};

export function getStageLabel(stage, stages = CRM_STAGE_OPTIONS) {
  return stages.find((s) => s.value === stage)?.label ?? stage;
}

export function mergeStageOptions(remoteStages) {
  if (!Array.isArray(remoteStages) || remoteStages.length === 0) {
    return CRM_STAGE_OPTIONS;
  }
  const byValue = new Map(
    remoteStages.map((s) => [s.value, String(s.label || "").trim() || s.value])
  );
  return CRM_STAGE_OPTIONS.map((s) => ({
    value: s.value,
    label: byValue.get(s.value) || s.label,
  }));
}
